export function trackEvent(
    category: string,
    action: string,
    name?: string,
    value?: string | number
) {
    (window as any)._paq.push(['trackEvent', category, action, name, value]);
}
